// src/components/auth/EmailVerification.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [isVerifying, setIsVerifying] = useState(true);
  const [verificationStatus, setVerificationStatus] = useState('');
  const [error, setError] = useState('');
  
  const { verifyEmail } = useAuth();
  
  useEffect(() => {
    const verifyToken = async () => {
      console.log('EmailVerification: Starting verification process');
      console.log('EmailVerification: Token from URL:', token);
      
      if (!token) {
        console.log('EmailVerification: No token found in URL');
        setIsVerifying(false);
        setError('Token za verifikaciju nedostaje');
        return;
      }
      
      try {
        console.log('EmailVerification: Calling verifyEmail function');
        const result = await verifyEmail(token);
        console.log('EmailVerification: Result from verifyEmail:', result);
        
        setIsVerifying(false);
        
        if (result.success) {
          console.log('EmailVerification: Verification successful');
          setVerificationStatus(result.message);
        } else {
          console.log('EmailVerification: Verification failed:', result.message);
          // Handle specific error cases
          if (result.message.includes('Invalid or expired')) {
            setError('Link za verifikaciju je nevažeći ili je istekao. Možda je email već verifikovan.');
          } else {
            setError(result.message);
          }
        }
      } catch (error) {
        console.error('EmailVerification: Verification process error:', error);
        setIsVerifying(false);
        setError('Došlo je do greške tokom verifikacije. Molimo pokušajte ponovo.');
      }
    };
    
    verifyToken();
  }, [token, verifyEmail]);
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Verifikacija e-maila</h2>
        </div>
        
        <div className="verification-content">
          {isVerifying ? (
            <div className="loading-message">
              <p>Verifikacija vaše e-mail adrese...</p>
              <div className="loading-indicator">
                <div className="dots">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            </div>
          ) : (
            <div>
              {error ? (
                <>
                  <div className="error-message">{error}</div>
                  <p>Molimo zatražite novi link za verifikaciju ili kontaktirajte podršku.</p>
                </>
              ) : (
                <>
                  <div className="success-message">
                    <div className="success-icon">
                      <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#4CAF50" strokeWidth="2"/>
                        <path d="m9 12 2 2 4-4" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <h3>Email uspješno verifikovan!</h3>
                    <p>{verificationStatus}</p>
                  </div>
                  <p>Sada se možete prijaviti na svoj račun i početi koristiti Poreznik AI.</p>
                </>
              )}
            </div>
          )}
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/app/login" className="auth-button" style={{ display: 'inline-block', maxWidth: '200px' }}>
              Idi na prijavu
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;